import axiosInstance from '../../../config/axiosInstance';
const CreateEngineer = async (formData, redirectCallback) => {
    try {
        const CompanyID = localStorage.getItem("CompanyID");
        formData.ClientID = CompanyID;
        const response = await axiosInstance.post(`/Job/CreateEngineerForJob`, formData);
        return response.data.message;
    } catch (error) {
        console.error('Error posting data:', error);
    }

};

export { CreateEngineer };